import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import CompanyForm from "@/pages/CompanyForm";
import SearchGrants from "@/pages/SearchGrants";
import Favorites from "@/pages/Favorites";
import Riepilogo from "@/pages/Riepilogo";

function FullLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC]">
      <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
    </div>
  );
}

function AppLayout() {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main><Outlet /></main>
    </div>
  );
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<PublicOnly><Auth /></PublicOnly>} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/app" element={<AppLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="aziende/nuova" element={<CompanyForm />} />
              <Route path="aziende/:id/modifica" element={<CompanyForm />} />
              <Route path="aziende/:id/bandi" element={<SearchGrants />} />
              <Route path="preferiti" element={<Favorites />} />
              <Route path="riepilogo" element={<Riepilogo />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
